import { Box } from "@mui/material";
import { useSyncExternalStore } from "react";

import { CaptionText } from "~/components/Typographies";
import chordPendingStore from "~/keyboard/chordPendingStore";

const ChordPendingIndicator = () => {
	const prefix = useSyncExternalStore(chordPendingStore.subscribe, chordPendingStore.get, () => null);
	if (!prefix) return null;

	return (
		<Box
			sx={{
				alignItems: "center",
				backgroundColor: "background.paper",
				border: 1,
				borderColor: "divider",
				borderRadius: 1,
				bottom: 16,
				boxShadow: 3,
				display: "flex",
				gap: 0.75,
				left: 16,
				position: "fixed",
				px: 1.25,
				py: 0.75,
				zIndex: (theme) => theme.zIndex.tooltip
			}}
		>
			<Box
				component="kbd"
				sx={{
					backgroundColor: "action.hover",
					border: 1,
					borderColor: "divider",
					borderRadius: 0.75,
					fontFamily: "'JetBrains Mono', monospace",
					fontSize: "0.72rem",
					px: 0.75,
					py: 0.25,
					textTransform: "uppercase"
				}}
			>
				{prefix}
			</Box>
			<CaptionText sx={{ color: "text.secondary" }}>then a key…</CaptionText>
		</Box>
	);
};

export default ChordPendingIndicator;
